var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"metrics-empty-state"},[_c('div',{staticClass:"paragraph-m"},[_vm._v(" "+_vm._s(_vm.title || _vm.$t("metrics.noDataAvailable"))+" ")]),_c('div',{staticClass:"paragraph-s"},[_vm._v(" "+_vm._s(_vm.description || _vm.$t("metrics.noDataAvailableDescription"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }